import styled from 'styled-components';
import { space, typography } from 'styled-system';
import { themeGet, color } from '@magalu/stereo-ui-styles';
import { fadeIn } from '../../utils';
export const Container = styled.div.attrs(props => Object.assign({}, props))`
  border-radius: ${props => themeGet('radii.default')(props)};
  background-color: ${props => props.backgroundColor || 'white'};
  animation: ${fadeIn} 0.2s ease-in;

  #arrow {
    position: absolute;
    width: 16px;
    height: 16px;
    &:after {
      content: ' ';
      background-color: ${props => props.backgroundColor || 'white'};
      position: absolute;
      width: 16px;
      height: 16px;
      transform: rotate(45deg);
      ${color}
    }
  }

  &[data-popper-placement^='bottom'] > #arrow {
    top: -8px;
    :after {
      left: 0;
    }
  }

  &[data-popper-placement^='top'] > #arrow {
    bottom: -8px;
    :after {
      left: 0;
    }
  }

  &[data-popper-placement^='right'] > #arrow {
    left: -6px;
  }

  &[data-popper-placement^='left'] > #arrow {
    right: -6px;
  }

  ${space}
  ${typography}
  ${color}
`;